import { DataCache, QueryResultsRelationship, ForeignKeyRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PilotsNavbarCache } from '../pilotsheader/cache';
import {
    DispatchDashboard,
    DispatchDashboardOptions,
    DispatchDashboardCorePermissions,
} from 'data/models/DispatchDashboard';
import { MissingPilotJobOrdersResponse, MissingPilotJobOrder } from 'data/models/MissingPilotJobOrders';
import { DispatchEventDetailsBilling } from 'data/models/DispatchEventDetailsBilling';

export class DispatchDashboardCache extends DataCache {
    DispatchDashboards    = PCCollection<DispatchDashboard, DispatchDashboardOptions>(DispatchDashboard);
    CorePermissions       = PCCollection(DispatchDashboardCorePermissions);
    MissingPilotJobOrdersResponses = PCCollection(MissingPilotJobOrdersResponse);
    MissingPilotJobOrders = PCCollection(MissingPilotJobOrder);
    DispatchEventDetailsBillings = PCCollection(DispatchEventDetailsBilling);
    
    constructor(data : PCCache, navbarCache : PilotsNavbarCache) {
        super();

        new ForeignKeyRelationship(data.PilotAgencies, this.DispatchDashboards, null, d => d.PilotAgency, d => d.Id());

        new QueryResultsRelationship(this.DispatchDashboards, data.DispatchEvents,  d => d.DispatchEvents);
        new QueryResultsRelationship(this.DispatchDashboards, data.PilotJobOrders,  d => d.JobOrders);
        new QueryResultsRelationship(this.DispatchDashboards, data.PilotJobOrderUserPreferenceses, d => d.PilotJobOrderUserPreferences);

        new SharedKeyRelationship(this.DispatchEventDetailsBillings, data.DispatchEvents, b => b.DispatchEvent, null);

        new ForeignKeyRelationship(this.CorePermissions,      this.DispatchDashboards, null, d => d.CorePermissions, d => d.Id());
        new ForeignKeyRelationship(navbarCache.PilotsNavbars, this.DispatchDashboards, null, d => d.Navbar, d => d.Id());

        new QueryResultsRelationship(this.MissingPilotJobOrdersResponses, this.MissingPilotJobOrders, r => r.MissingPilotJobOrders);
    }
}



// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/cache.ts